import Swiper from 'swiper';
import {Autoplay} from 'swiper/modules';

export default class Slider {
    constructor() {
        const swiper = new Swiper('.testimonial-swiper', {
            loop: true,
            modules: [Autoplay],
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
        });
    }
}